var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',[(_vm.currentView == 'map')?_c('follow-map'):(_vm.currentView == 'graph')?_c('div',[_vm._v("Graph")]):(_vm.currentView == 'table')?_c('follow-table'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }